import * as React from "react";

const Share = (props: { color?: string }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g
                style={{ stroke: props.color ?? "var(--theme-icon-fill-white)" }}
                strokeWidth="1.33333"
                strokeLinecap="round"
            >
                <circle cx="15" cy="4.16666" r="2.5" />
                <circle cx="5" cy="10" r="2.5" />
                <circle cx="15" cy="15.8333" r="2.5" />
                <line x1="7.1582" y1="11.2583" x2="12.8499" y2="14.575" />
                <line x1="12.8415" y1="5.42499" x2="7.1582" y2="8.74165" />
            </g>
        </svg>
    );
};

export default Share;
